// extracted by mini-css-extract-plugin
export default {"link":"AttendancePage_link__wtPqA"};